export default __webpack_public_path__ + "static/media/customization_bg.61b8350f.png";